function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M211.6 210.9l36.1-44.3h-21.3l7.7-26.5-36 44.2h21.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.6 85V62.8c0-19-15.4-34.4-34.4-34.4H80.5c-19 0-34.4 15.4-34.4 34.4V85H0v198.4h120.5V85H74.6V62.8c0-3.3 2.6-5.9 5.9-5.9h122.8c3.3 0 5.9 2.6 5.9 5.9V85H163v198.4h120.5V85h-45.9zM92 255H28.5V113.5H92V255zm163 0h-63.5V113.5H255V255z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.5 127.5h35.4v28.3H42.5zM42.5 212.6h35.4v28.3H42.5zM42.5 170h35.4v28.3H42.5z"
})));